import { Col, Row } from "reactstrap";
import { Href, IconsTitle } from "../../../Constants/Constants";
import { ButtonSizes, ButtonVariants, IconTypes } from "../../../Data/Bonus/Elements";

const RenderButtons = (size = "", isDot = false, grow = false) =>
  ButtonVariants.map((variant, index) => (
    <div key={index} className={`${isDot ? `dot-btn dot-${variant.includes("outline") ? variant.split("-")[2] : variant.split("-")[1]}` : ""} ${grow ? "grow" : ""}`}>
      <a className={`icon-btn button-effect ${variant} ${size}`} href={Href}>
        {IconTypes[index % IconTypes.length]}
      </a>
    </div>
  ));

const Icons = () => (
  <section className="Icons">
    <Row>
      <Col xs="12">
        <div className="element-card">
          <div className="element-card-header heading">
            <h2>{IconsTitle}</h2>
          </div>
          <div className="element-card-body typography">
            <div className="fonts">{RenderButtons()}</div>
          </div>
          <div className="element-card-body typography">
            <div className="fonts">{RenderButtons("", true)}</div>
          </div>
          {ButtonSizes.slice(0, 2).map((size) => (
            <div key={size} className="element-card-body typography">
              <div className="fonts">{RenderButtons(size)}</div>
            </div>
          ))}
          <div className="element-card-body typography">
            <div className="fonts">{RenderButtons("", true, true)}</div>
          </div>
          {ButtonSizes.slice(2).map((size) => (
            <div key={size} className="element-card-body typography">
              <div className="fonts">{RenderButtons(size)}</div>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  </section>
);

export default Icons;
